/**------------------------------------------------------
 * Enum Definitions
 */
export enum EnumNgTimeOptions {
	pastTime 	  = 'past_time',
	remainingTime = 'remaining_time'
}
